import { connectMediaStore } from './withOwnReduxStore';
import { getAllowUploads, getAllowMultipleUploads } from '../selectors';
import { uploadFile, uploadFiles } from '../actions';
import { getUploads } from '../../redux/uploads/selectors';
export default connectMediaStore(function (state) { return ({
    fileUploads: getUploads(state),
    allowUploads: getAllowUploads(state),
    allowMultipleUploads: getAllowMultipleUploads(state),
}); }, { uploadFile: uploadFile, uploadFiles: uploadFiles });
//# sourceMappingURL=withFileUpload.js.map